import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { AvailableEnrichmentProfile } from "../../recommendation.types";
import { requestGetAvailableEnrichmentProfiles } from "./getAvailableEnrichmentProfiles.request";

const useAvailableEnrichmentProfiles = (
  options?: QueryOptions<
    AvailableEnrichmentProfile[],
    ApiServiceError<ApiError>
  >
) => {
  const { data: availableProfiles, ...rest } = useQuery({
    queryKey: ["recommendation", "enrichment", "profiles", "available"],
    queryFn: requestGetAvailableEnrichmentProfiles,
    onError: toastServerError,
    ...options
  });

  return { availableProfiles: availableProfiles ?? [], ...rest };
};

export default useAvailableEnrichmentProfiles;
